<template>
  <settings-modal
    class="payment-return-reject-modal t-payment-return-reject-modal"
  >
    <template slot="heading">{{ heading }}</template>

    <p>
      Specify reject reason:
    </p>

    <v-checkbox
      v-for="(option, key) in rejectReturnReasonOptions"
      :key="key"
      v-model="rejectReason"
      color="primary"
      :label="option.name"
      :value="option.value"
      :error-messages="getValidationErrorMessage('rejectReason')"
      hide-details
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        id="accept"
        color="primary"
        medium
        flat
        @click="onConfirmButtonClick"
      >reject return request</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import rejectSepaReturnRequestReasons from '@/assets/data/sepa/reject-return-reasons.json'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  // Mixins
  import form from '@/mixins/form'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  export default {
    name: 'RejectSepaReturnRequestModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        rejectSepaTopupReturn: new ApiRequest(PaymentApi.rejectSepaTopupReturnRequest),
        rejectReason: null
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      payment () {
        return this.modal.data.payment
      },
      heading () {
        return 'Reject sepa return request'
      },
      error () {
        return this.rejectSepaTopupReturn.error
      },
      rejectReturnReasonOptions () {
        return Object.entries(rejectSepaReturnRequestReasons).map(([ code, reason ]) => ({
          name: `(${code}) ${reason}`,
          value: code
        }))
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.rejectSepaTopupReturn
          .execute(this.payment.id, this.rejectReason)
          .then(this.createReturnSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      createReturnSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Sepa topup return request has been rejected.' }
          })
        }, 100)
      }
    }
  }
</script>
